import ControlViewModel from '@/ViewModels/ControlViewModel';
import ComponentManager from '@/Management/ComponentManager';
import ResourceManager from '@/Management/ResourceManager';
import LinkViewModel from '@/ViewModels/Controls/LinkViewModel';
import LabelViewModel from '@/ViewModels/Controls/LabelViewModel';
import ImageViewModel from '@/ViewModels/Controls/ImageViewModel';
import WindowViewModel from '@/ViewModels/Controls/WindowViewModel';

export default class RichTextBoxViewModel extends ControlViewModel {

    private LinkViewModel = ComponentManager.getViewModel<typeof LinkViewModel>('LinkViewModel');
    private LabelViewModel = ComponentManager.getViewModel<typeof LabelViewModel>('LabelViewModel');
    private ImageViewModel = ComponentManager.getViewModel<typeof ImageViewModel>('ImageViewModel');

    /**
     * Der Wert der RichTextBox
     */
    public value: KnockoutObservable<string>

    /**
     * Gibt die Sprache des eingegebenen Textes an
     */
    public language: KnockoutObservable<string>;

    /**
     * Gibt an, ob bereits ein Window erzeugt wurde
     */
    public windowCreated: boolean;

    /**
     * Definiert die angezeigten Werkzeuge zur Bearbeitung des Texts
     */
    public tools: KnockoutComputed<string[]>;

    /**
     * Definiert die angezeigten Texte zu den möglichen Tools
     */
    public messages: KnockoutComputed<any>;

    /**
     * Ein Handler, der aufgerufen wird, wenn sich der Wert verändert
     */
    public onChange: Function;

    /**
     * Funktion die nach der Initalisierung aufgerufen wird
     */
    public onAfterInit: Function;
    /**
     * Das ViewModel für das Vergrößerungs-Fenster
     */
    public window: WindowViewModel;

    /**
     * Das ViewModel für den Link für das Vergrößerungs-Fenster
     */
    public link: LinkViewModel;

    /**
     * Gibt die maximale Länge des Textes an (ohne Formatierungen)
     */
    public maxLength: number;

    /**
     * Das ViewModel für die RichtTextBox
     * @param {object} params - Ein Objekt mit Optionen für das Control
     * @constructor
     */
    public constructor(params: any) {
        super(params);

        this.value = this.observableOrDefault(params.value, '');
        this.language = this.observableOrDefault(params.language, ResourceManager.getInstance().language.value());
        this.windowCreated = this.paramOrDefault(false);
        this.tools = this.defineComputed( () => {
            let result = [];
            let isEnabled = this.isEnabled();

            if (isEnabled === true) {
                result.push('bold');
                result.push('italic');
                result.push('underline');
                result.push('justifyLeft');
                result.push('justifyCenter');
                result.push('justifyRight');
                result.push('justifyFull');
            }

            return result;
        });

        this.messages = this.defineComputed( () => {
            return {
                bold: '',
                italic: '',
                underline: '',
                justifyCenter: '',
                justifyLeft: '',
                justifyRight: '',
                justifyFull: '',
                fontSize: '',
                fontSizeInherit: '',
                foreColor: ''
            };
        });
        this.onAfterInit = this.handlerOrDefault(params.onAfterInit);
        this.onChange = this.handlerOrDefault(params.onChange);
        this.window = this.paramOrDefault(params.window, null);
        this.link = this.paramOrDefault(( () => {           
            if (this.window != null) {
                return new this.LinkViewModel({
                    parentLocator: this.locator,
                    locator: 'toolbar.toggle-window',
                    image: new ImageViewModel({
                        parentLocator: this.locator,
                        locator: 'toolbar.toggle-window.image',
                        source: this.defineComputed( () => {
                            let isOpen = this.window.isOpen();

                            if (isOpen === false) {
                                return 'RichTextEditor/zoom_in.png';
                            } else {
                                return 'RichTextEditor/zoom_out.png';
                            }
                        }),
                        alternativeText: new LabelViewModel({
                            ergName: this.defineComputed( () => {
                                let isOpen = this.window.isOpen();

                                if (isOpen === false) {
                                    return 'FACTORY_TEXTEDITOR_ZOOMIN';
                                } else {
                                    return 'FACTORY_TEXTEDITOR_ZOOMOUT';
                                }
                            })
                        })
                    }),
                    isFocusable: this.isFocusable,
                    onClick: () => {
                        this.window.isOpen.toggle();
                    }
                });
            } else {
                return null;
            }
        })());

        this.maxLength = this.paramOrDefault(params.maxLength, -1);
        this.isValid = this.observableOrDefault(params.isValid, true);
    }

    public resetValue(): void {
        this.value("");
    }
}

ComponentManager.setViewModel('RichTextBoxViewModel', RichTextBoxViewModel, 'RADPresentation.HTMLClient.DefaultViewExtensions');